import { Select } from "../utilities";


export class ChampFormOM {

  public Ident: string;

  public TypeFormulaire: string;

  public Name: string;

  public Code: string;

  public Type: string;

  public Obliger: boolean;

  public Order: number;

  public IdLigne: string;

  public Value: string;

  public ComboOptions: Array<Select>;

  public Column: string;

}
